import { createGlobalStyle } from 'styled-components';
import 'normalize.css';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

const ROOT_FONT_SIZE_PIXELS = '16px';

const NiGlobalStyle = createGlobalStyle`
	:root {
		font-size: ${ROOT_FONT_SIZE_PIXELS};
	}

	.tqc-date-picker__calendar-icon {
	  z-index: 1;
	}
	
	.react-datepicker-popper {
      z-index: 3 !important;
    }
	
	.tqc-menu__menu-button:active,
	.tqc-menu__menu-button[data-active] {
		background-color: ${COLOURS.blue[100]};
		border-color: ${COLOURS.blue[600]};
		color: ${COLOURS.blue[600]};
	}
	
  .tqc-button__icon {
    right: 0.7rem;
  }
  
	.tqc-form-control label + span {
	  display: flex;
	}
	
	.label__required-indicator {
	  margin-left: 0.25rem;
	  margin-right: 0.125rem;
	}
    
  .chakra-table {
    th, td {
      padding-top: 0.5rem !important;
      padding-bottom: 0.5rem !important;
      letter-spacing: 0;
    }
  }
  
  .tqc-menu__menu-list button {
    padding-top: 8px;
    padding-bottom: 8px;
    line-height: 24px;
  }
  
  .tqc-tabs__tab-panels {
    overflow: auto;
  }
  
 
  
  .tqc-menu__menu-button + div {
    z-index: 2;
  }

  /* Mobile up to tablet styling for statistics */
  @media all and (max-width: 768px) {
    .recharts-wrapper, .recharts-wrapper svg {
      height: 110px !important;
      width: 110px !important;
    }

    .chart-header  {
      padding: 0.25rem 0.7rem;
    }

    .chart-container {
      width: calc(100% - 112px);
    }

    .chart-centre-container {
      height: 110px;      
    }

    .chart-centre-text {
      line-height: 1.1rem;
      font-size: 0.9rem;      
    }

    .stat-legend-title, .stat-legend-percentage, .stat-legend-percentage-symbol {
      font-size: 0.75rem;
    }
  
    .stat-legend-line {
      padding: 0.3rem 0.5rem;        
    } 
  }

  /* Smaller mobile styling for statistics */
  @media all and (max-width: 374px) {
    .stat-legend-title {
      font-size: 0.65rem;
    } 
    
    .stat-legend-percentage, .stat-legend-percentage-symbol {
      font-size: 0.65rem;
    }   
    
    .stat-legend-percentage-container {
      width: 34px;
      min-width: 34px
    }        
  }
  
`;

export default NiGlobalStyle;
